// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"g2-z","dimensionLabel":"h2-z","styleChooserControlWrapper":"i2-z","styleChooserControl":"j2-z","disabled":"k2-z","giftCard":"l2-z","styleChooserText":"m2-z"};